import React, { useMemo, useState } from "react";

import type { ShiftActionsController, ShiftActionsProps } from "@/components/sections/ShiftActions.types.tsx";
import type { Schedule, Shift } from "@/types.ts";
import { formatShiftTime, categorizeAssignableEmployees, SHIFT_ASSIGNMENT_GROUP_LABEL, SHIFT_ASSIGNMENT_WARNING_UI } from "@/utils/schedulerUtils.ts";
import { BadgeInfo, User, Info } from "lucide-react";
import CheckboxField from "@/components/forms/CheckboxField.tsx";
import ShiftAssignmentList from "@/components/sections/ShiftAssignmentList.tsx";

// function safeParseInputTimeSecondsToMilli(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds * 1000);
// }

// function safeParseInputIntNumber(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds);
// }

// function initOptionNumber(value:number | undefined | null, defaultInitValue:number):number{
//     if(value === void 0  || value ===null)return defaultInitValue;
//     return value
// }
export const SectionInputGroupWrapper: React.FC<{children: React.ReactNode , onClick? : ()=>void}> = (props)=>{
    return <div 
        onClick={props.onClick}
        className={`px-4 py-0 border-1 border-gray-300 rounded-sm my-2` + (props.onClick ? ' cursor-pointer' : '')}>
        {props.children}
    </div>
}
const SectionHeadingFlexWrapper:React.FC<{children: React.ReactNode}>  = (props) =>{
return <div className="flex items-center gap-2 items-center">
        {props.children}
    </div>
}


export function buildShiftActionsController(
    shiftId  : string | undefined,
    schedule : Schedule | undefined
) : ShiftActionsController{
    const shift:Shift | undefined = schedule? schedule.shifts.find(s => s.id === shiftId) : void 0;
    const [editData , setEditData] = useState({...{},...(shift ||{})});
    //const [selectedUserId , setSelectedUserId] = useState<string>();
    // const mapOfPhases = editData.mapOfPhases || {};
    // var entries =Object.entries(mapOfPhases);
    // var listOfUIPhases:SolverPhasesController["viewData"]["listOfUIPhases"] = [];
    // for (const [key, value] of entries) {
    //     if(value && value.active !== false){
    //         listOfUIPhases.push({
    //             name : value.name || "-",
    //             id : key,
    //             phase : value
    //         });
    //     }
    // }
    

    const timeRange = shift ? `${formatShiftTime(shift.start)} - ${formatShiftTime(shift.end)}` : '';
    const employeeName = shift ?(shift.employee?.name || "Non assigné" ): '';
    const roleName =shift ? (shift.roleName || shift.requiredSkill || "") : '';
    const selectedShiftId = shift?.shiftId || "";
    const selectedUserId=editData.employee?.id || "";
    const pinned =editData.pinned ===true;
    const categorizedGroups = useMemo(
        () => (shift && schedule) ? categorizeAssignableEmployees(shift, schedule) : [],
        [shift?.id, schedule],
    );

    const assignmentGroups: ShiftActionsController["viewData"]["assignmentGroups"] = categorizedGroups.map(group => ({
        key: group.key,
        label: SHIFT_ASSIGNMENT_GROUP_LABEL[group.key],
        items: group.items.map(candidate => ({
            id: candidate.id,
            name: candidate.name,
            selected: selectedUserId === candidate.id,
            badges: candidate.warnings.map(warning => ({ key: warning, ...SHIFT_ASSIGNMENT_WARNING_UI[warning] })),
        })),
    }));

    // "unqualified" is excluded: it holds everyone who lacks the role, so it is never empty.
    const noEmployeesForRole = categorizedGroups.length > 0
        && categorizedGroups.every(group => group.key === "unqualified" || group.items.length === 0);

    // A manual assignment may override the role requirement; only a *new* unqualified pick is worth
    // warning about, since an inherited one was already accepted.
    const selectedIsUnqualified = !!selectedUserId
        && selectedUserId !== shift?.employee?.id
        && categorizedGroups.some(
            group => group.key === "unqualified" && group.items.some(candidate => candidate.id === selectedUserId)
        );

    const viewData:ShiftActionsController["viewData"] = {
        selectedShift :shift,
        selectedShiftId : selectedShiftId,
        selectedUserId : selectedUserId,
        isPinned : pinned,
        uiShiftDetails : {
            userName: employeeName,
            roleName : roleName,
            displayTime:timeRange,
        },
        unassignItem : { id: "", name: "Aucune assignation", selected: selectedUserId === "" },
        assignmentGroups : assignmentGroups,
        noEmployeesForRole : noEmployeesForRole,
        selectedIsUnqualified : selectedIsUnqualified,

    }

    const initializeShiftEditDataFromShiftId = (shiftId:string)=>{
        const newShift:Shift | undefined = schedule? schedule.shifts.find(s => s.id === shiftId) : void 0;
        setEditData({...{}, ...(newShift||{})}  )
    }

    const selectUser = (userId:string)=>{
        const foundEmployeeItem = userId ?  schedule?.employees.find((item)=>{return item.id === userId}) :void 0;
        setEditData({...editData, ...{employee : foundEmployeeItem}})
    }
    const togglePinned = ()=>{
      //  const foundEmployeeItem = userId ?  schedule?.employees.find((item)=>{return item.id === userId}) :void 0;
        setEditData({...editData, ...{pinned : !editData.pinned}})
    }

    return {
        setEditData,
        editData,
        viewData,
        initializeShiftEditDataFromShiftId,
        selectUser,
        togglePinned
    }
}


/**
 * Main component
 * @param param0
 * @returns 
 */
const ShiftActions: React.FC<ShiftActionsProps> = (props) => {

    //const [editData , setEditData] = useState({...{},...solverConfigs});
    const ctrl =props.controller;
    const setEditData = ctrl.setEditData;
    const editData = ctrl.editData;
    const viewData = ctrl.viewData;

    return (
         <div className="text-gray-700">

                <SectionInputGroupWrapper>
                    <div style={{height:"0.5rem"}}></div>
                    <SectionHeadingFlexWrapper>
                        <BadgeInfo />
                       <span className="text-base font-bold">Details du quart:</span>
                    </SectionHeadingFlexWrapper>
                    <div>
                        <span className="text-sm">{viewData.uiShiftDetails.userName}</span>
                    </div>
                    <div>
                        <span className="text-sm">{viewData.uiShiftDetails.roleName}</span>
                    </div>
                    <div>
                        <span className="text-sm">{viewData.uiShiftDetails.displayTime}</span>
                    </div>
                    <div style={{height:"0.25rem"}}></div>
                </SectionInputGroupWrapper>

                {!viewData.selectedShiftId ? <>
                    <div style={{height:"1rem"}}></div>
                    <CheckboxField
                        label={'Mettre le quart comme non modifiable par le solveur'}
                        checked={viewData.isPinned}
                        onChange={() => ctrl.togglePinned()}
                    />
                    <div style={{height:"1rem"}}></div>
                    <SectionHeadingFlexWrapper>
                        <User />
                        <span className="text-base font-bold">Assignation</span>
                    </SectionHeadingFlexWrapper>
                    <div className=" p-1 border-b border-gray-200"> </div>

                    {viewData.selectedIsUnqualified && (
                        <div className="mb-2 p-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded">
                            Cet employé n'a pas le rôle du quart : l'assignation sera tout de même enregistrée.
                        </div>
                    )}

                    <ShiftAssignmentList
                        unassignItem={viewData.unassignItem}
                        assignmentGroups={viewData.assignmentGroups}
                        noEmployeesForRole={viewData.noEmployeesForRole}
                        onSelect={ctrl.selectUser}
                    />
                </> : <>
                    <div style={{height:"1rem"}}></div>
                    <SectionHeadingFlexWrapper>
                        <Info />
                        <span className="text-base font-bold">Quart non modifiable car déjà publié</span>
                    </SectionHeadingFlexWrapper>
                </>}


         </div>
    );
};

export default ShiftActions;
